import { render, staticRenderFns } from "./shelfTime.vue?vue&type=template&id=1b6408f4&scoped=true&"
import script from "./shelfTime.vue?vue&type=script&lang=js&"
export * from "./shelfTime.vue?vue&type=script&lang=js&"
import style0 from "./shelfTime.vue?vue&type=style&index=0&id=1b6408f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6408f4",
  null
  
)

export default component.exports